import React from "react";
import {Modal} from "react-bootstrap";
import {useModal} from "../../context/ModalContext";
import FormMerchant from "../Form/FormMerchant";

const ModalB: React.FC = () => {
    const {showModalB, closeModals} = useModal();

    return (
        <Modal show={showModalB} onHide={closeModals} centered>
            <Modal.Header closeButton>
                <Modal.Title>Оформление сервиса</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormMerchant closeModal={closeModals}/>
            </Modal.Body>
        </Modal>
    );
};

export default ModalB;
